export const styles = theme => ({
  root: {
    position: 'absolute',
    height: 95,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
    opacity: 0.9,
    alignItems: 'center',
    bottom: 0,
    padding: 0,
    [theme.breakpoints.down('600')]: {
      height: '220px !important',
    },
  },
  sectionPageRoot: {
    height: 183,
    opacity: 1,
    position: 'relative',
    '& div': {
      ...theme.typography.body1,
    },
    '& p': {
      ...theme.typography.body1,
    },
  },
  fixRoot: {
    left: 0,
    position: 'fixed',
    textAlign: 'center',
    bottom: 0,
    width: '100%',
    opacity: 1,
    zIndex: 999,
    height: 'auto',
    padding: 20,
    '& div': {
      textAlign: 'left',
    },
    '& p': {
      paddingLeft: 8,
    },
    '& button': {
      width: 90,
    },
  },
  button: {
    color: theme.palette.primary.main,
    boxShadow: 'none',
    width: 136,
    height: 40,
    fontFamily: 'PoppinsSemiBold',
    [theme.breakpoints.down('900')]: {
      width: 'auto',
    },
    [theme.breakpoints.down('600')]: {
      width: 136,
    },
    backgroundColor: '#fff',
    borderRadius: 20,
  },
  mobileFilter: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  label: {
    fontSize: 20,
    fontFamily: 'PoppinsMedium',
    color: '#fff',
  },
  inlineLabel: {
    display: 'inline-block',
  },
  desktopWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.breakpoints.down('770')]: {
      '& p': {
        fontSize: 17,
      },
      '& div': {
        fontSize: 17,
      },
    },
  },
  sectionDesktopWrapper: {
    justifyContent: 'center',
    '& > div': {
      margin: '0 10px',
    },
  },
  splashImg: {
    height: 264,
    [theme.breakpoints.down('600')]: {
      height: 'auto',
      width: '100%',
    },
  },
  splashImgWrapper: {
    height: 264,
  },
  buttonLink: {
    textDecoration: 'none',
  },
  textLink: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 13,
  },
  heroText: {
    color: '#fff',
  },
});
